/**
 * 兼容 string.prototype.replaceAll 方法
 * @param inputString
 * @param searchValue
 * @param replaceValue
 * @returns
 */
export function replaceAll(inputString: string, searchValue: string, replaceValue: string): string {
    if (typeof inputString.replaceAll === 'function') {
        return inputString.replaceAll(searchValue, replaceValue);
    }
    // 部分旧浏览器不支持 replaceAll，使用 replace 代替
    return inputString.replace(new RegExp(searchValue, 'g'), replaceValue);
}
